import { HttpErrorResponse } from '@angular/common/http';

export function isFatalErrorCode(error: HttpErrorResponse): boolean {
  return !!error.status?.toString().match(/^5..$/g);
}
